import {
  FETCH_USER_PROFILE,
  GET_PACKAGE_BY_ID,
  GET_PACKAGE_BY_ID_STATUS,
  GET_PACKAGE_LISTING,
  GET_PACKAGE_LISTING_COUNT,
} from "../../data/APIEndpoints";
import axios from "../AxiosInstance";

const getPackageListing = async (
  roleId,
  type,
  pgNo,
  pgSize,
  searchParams,
  filterParams,
  CurrentLatitude,
  CurrentLongitude,
  acceptedBy,
  requestedBy
) => {
  var url =
    GET_PACKAGE_LISTING +
    `?JobStatusId=${type}&PageNumber=${pgNo}&PageCount=${pgSize}`;

  if (searchParams) {
    url = url + `&SearchCity=${searchParams}`;
  }
  if (roleId) {
    url = url + `&RoleId=${roleId}`;
  }
  if (CurrentLatitude && filterParams?.miles && type !== 0) {
    url = url + `&CurrentLatitude=${CurrentLatitude}`;
  }
  if (CurrentLongitude && filterParams?.miles && type !== 0) {
    url = url + `&CurrentLongitude=${CurrentLongitude}`;
  }
  if (filterParams?.miles) {
    url = url + `&RadiusInMiles=${filterParams.miles}`;
  }
  if (filterParams?.sortBy) {
    url = url + `&SortBy=${filterParams.sortBy}`;
  }
  if (acceptedBy) {
    url = url + `&AcceptedBy=${acceptedBy}`;
  }
  if (requestedBy) {
    url = url + `&RequestedBy=${requestedBy}`;
  }

  try {
    const response = await axios.get(url);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Failed to Load Listing",
      error: error,
    };
  }
};

const getPackageListingCount = async (roleId) => {
  const url = GET_PACKAGE_LISTING_COUNT + `?RoleId=${roleId}`;
  try {
    const response = await axios.get(url);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Failed to Load Listing Count",
      error: error,
    };
  }
};

const getPackageDetailsbyId = async (id) => {
  const url = GET_PACKAGE_BY_ID;
  try {
    const packageId = isNaN(id) ? `?jobCode=${id}` : `?jobId=${id}`;
    const response = await axios.get(`${url}${packageId}`);
    if (response.status === 200) {
      return {
        status: "success",
        data: response.data,
      };
    } else {
      return {
        status: "error",
        message: "Failed to fetch package details.",
      };
    }
  } catch (error) {
    return {
      status: "error",
      error: error.response || error.message,
    };
  }
};

const putPackageStatusById = async (payload) => {
  try {
    const response = await axios.put(`${GET_PACKAGE_BY_ID_STATUS}`, payload);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    if(error.response.data.message){
      return {
          status: "error",
          message: error.response.data.message,
          error: error,
      };
    } else {
      return {
        status: "error",
        message: `Error updating job status: ${error}`,
        error: error,
      };
    }
  }
};

const putPackageReviewById = async (payload) => {
  try {
    const response = await axios.put(`${GET_PACKAGE_BY_ID_STATUS}`, payload);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    if(error.response.data.message){
      return {
          status: "error",
          message: error.response.data.message,
          error: error,
      };
    } else {
      return {
        status: "error",
        message: `Error updating job status: ${error}`,
        error: error,
      };
    }
  }
};

const DeleteJobById = async (packageId, userId) => {
  try {
    const url = `jobmanagement/deletejob?packageId=${packageId}&userId=${userId}`;
    const response = await axios.put(url);
    if (response.status === 200) {
      return { status: "success", data: response.status };
    }
  } catch (err) {
    if(err.response.data.message){
      return {
          status: "error",
          message: err.response.data.message,
          error: err,
      };
    } else {
      return {
        status: "error",
        message: `Error Deleting job status: ${err.message}`,
        error: err.message,
      };
    }
  }
};

const getUserProfile = async (userId) => {
  try {
    const response = await axios.get(`${FETCH_USER_PROFILE}`, {
      params: { userId },
    });
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: `Error getting profile details: ${error}`,
      error: error,
    };
  }
};

const editUserProfile = async (profile) => {
  try {
    const response = await axios.put(`${FETCH_USER_PROFILE}`, profile);
    return response.data;
  } catch (error) {
    console.error("Error updating user profile:", error);
    throw error;
  }
};

const PackageListings = {
  getPackageListing,
  getPackageListingCount,
  getPackageDetailsbyId,
  putPackageStatusById,
  putPackageReviewById,
  getUserProfile,
  editUserProfile,
  DeleteJobById,
};

export default PackageListings;
